import Vue from 'vue';
import { extend } from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules';

// register VeeValidate rules
extend('required', required);
extend('email', email);
extend('min', {
  ...min,
  params: ['length'],
  message: '{_field_} must be at least {length} characters long'
});
extend('password', {
  validate: value => {
    const strongRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])'
    );
    return strongRegex.test(value);
  },
  message:
    'Password must include at least one uppercase letter, one lowercase letter, ' +
    'one special character(like ! and $) and a number'
});
extend('password_confirm', {
  params: ['target'],
  validate: (value, { target }: Record<string, any>) => {
    return value === target;
  },
  message: 'Password confirmation does not match'
});
